import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchYardRx } from '../redux/PerformanceReducer/Ecommerce/yardRxSlice';
import { selectIsMultiStoreEnabled, selectUserDetails } from '../redux/UserReducer/userSlice';
import { getEffectiveStoreNumber } from '../utils/appUtils';

export const useYardRxData = (): void => {
  const dispatch = useAppDispatch();
  const userDetails = useAppSelector(selectUserDetails);
  const isMultiStoreEnabled = useAppSelector(selectIsMultiStoreEnabled);

  const effectiveStoreNumber = useMemo(
    () => getEffectiveStoreNumber(userDetails, isMultiStoreEnabled),
    [userDetails, isMultiStoreEnabled],
  );

  useEffect(() => {
    if (!effectiveStoreNumber) return;
    dispatch(
      fetchYardRx({
        storeNumber: effectiveStoreNumber,
        isMultiStoreMode: isMultiStoreEnabled,
      }),
    );
  }, [dispatch, effectiveStoreNumber, isMultiStoreEnabled]);
};
